import React from 'react';

import { FiChevronLeft, FiChevronRight } from '@fmbt/ui/icons';
import AgriWebbLogo from 'components/icons/AgriWebbLogo/agriwebb-logo.svg?react';
import FarmbotIcon from 'components/icons/FarmbotIcon';

import './styles.less';

const FarmbotAgriWebbIntegrationTitle = ({
  children
}: {
  children: string;
}) => (
  <div className="FarmbotAgriWebbIntegrationTitle">
    <div className="FarmbotAgriWebbIntegrationTitle-icons">
      <FarmbotIcon style={{ height: '44px' }} />
      <FiChevronLeft className="FarmbotAgriWebbIntegrationTitle-arrows left" />
      <FiChevronRight className="FarmbotAgriWebbIntegrationTitle-arrows" />
      <AgriWebbLogo style={{ width: '60px' }} />
    </div>
    <div className="FarmbotAgriWebbIntegrationTitle-text">{children}</div>
  </div>
);

export default FarmbotAgriWebbIntegrationTitle;
